<template>
  <!-- 小红书列表 -->
  <div>
    <div class="topBox">
      <div class="leftBox">为你找到了<strong>{{pager.total}}</strong>位合适的达人</div>
      <div class="table-head-slot">
        <el-button round size="mini" @click="showCustomDialog">
          <i class="el-icon-setting" style="margin-right: 6px;"></i>自定义列
        </el-button>
        <el-button size="mini" round  v-if="isShowCalendar == 1" @click="batchLockHandle"><i class="el-icon-lock" style="margin-right: 6px;"></i>批量锁档</el-button>
        <el-button size="mini" round  @click="onDrCartBatchJoin"><i class="el-icon-shopping-cart-2" style="margin-right: 6px;"></i>批量添加至清单</el-button>
        <el-button size="mini" round @click="showExportDialg"><i class="el-icon-upload2" style="margin-right: 6px;"></i>导出</el-button>
      </div>
    </div>
    <div class="xhs-table-wrap">
      <div class="my-vxe-table-wrap" v-if="myColumns.length">
        <vxe-table
          v-fixed-table-header
          ref="mainTableRef"
          border="inner"
          class="xhs-main-table"
          :row-config="{isHover: true}"
          :scroll-y="{enabled: true}"
          align="center"
          :loading = "loading"
          :data="vxeTableData"
          @cell-dblclick="tableBtnClick"
          @sort-change="sortChange"
          :sort-config="{remote:true, defaultSort: {field: 'fans', order: 'desc'}}"
          :row-class-name="rowClassName"
          >
          <vxe-column type="checkbox" width="40" fixed="left"></vxe-column>
          <vxe-column fixed="left" width="340" title="达人信息">
              <template #default="{row}">
                <div class="profile-wrap">
                  <div class="img-wrap">
                    <img class="avatar" :src="row.avatar_uri" v-if="row.avatar_uri" alt="">
                    <img class="avatar" src="./../../../assets/images/avatar.jpg" v-else alt="">
                    <img class="sex" v-if="row.sex" :src="require(`@/assets/${row.sex === '男' ? 'man' : 'woman'}.png`)" alt="" style="width: 20px;height: 20px;" />
                  </div>
                  <div class="info-wrap">
                    <div class="nickname">
                      <img v-if="row?.month_examples_data?.is_hot == '是'" :src="require(`@/assets/images/火爆.png`)" style="margin-right: 4px;">
                      <img v-if="row?.month_examples_data?.is_must == '是'" :src="require(`@/assets/images/必选.png`)" style="margin-right: 4px;">
                      <el-popover trigger="hover">
                        <div class="popover-form">
                          <div class="item">
                            <div class="label">小红书号</div>
                            <div class="value">{{ row.shortid }}</div>
                          </div>
                          <div class="item">
                            <div class="label">主页链接</div>
                            <i v-clipboard:copy="row.homepage" style="color: blue;cursor: pointer;" v-clipboard:success="onCopy">复制链接</i>
                          </div>
                          <div v-if="row?.is_ban == 1 || row?.is_black == 1 || row?.is_sup_black == 1"  class="item">
                            <div class="label">达人情况说明</div>
                            <div class="value">
                              <span v-if="row?.is_ban == 1">不推荐</span>
                              <span v-else-if="row?.is_black == 1 ">达人已被拉黑</span>
                              <span v-else-if="row?.is_sup_black == 1">归属供应商被拉黑</span>
                            </div>
                          </div>
                          <div v-if="row?.is_ban == 1 || row?.is_black == 1 || row?.is_sup_black == 1" class="item">
                            <div class="label">不推荐理由</div>
                            <div  class="value">
                              <template v-if="row?.is_ban == 1 ">
                                {{ row?.ban_data?.reason }}
                              </template>
                              <template v-if="row?.is_black == 1 || row?.is_sup_black == 1 ">
                                {{ row?.black_data?.black_reasons }}
                              </template>
                            </div>
                          </div>
                        </div>
                        <div slot="reference" class="sp-nickname" :class="{'gray-nickname': row?.is_ban == 1 || row?.is_black == 1 || row?.ban_data?.reason}" :title="row.nickname">{{ row.nickname }}</div>
                      </el-popover>
                      <el-tooltip v-if="row.warnTips" placement="top">
                        <div slot="content">
                          {{ row.warnTips }}
                        </div>
                        <i class="el-icon-warning-outline warnTips"></i>
                      </el-tooltip>
                      <img src="@/assets/images/schedule/i-calendar.png" class="i-calendar" alt="" v-if="['自孵化号','签约号'].includes(row.logings)" @click="showCalendarDia(row)">
                      <img v-if="row.is_competitive == 1" src="@/assets/images/schedule/排竞.png" class="pj_icon"  @click="showPjModal(row)">
                    </div>
                    <div class="tag-wrap">
                      <SupplierPopover v-if="row.logings" :disabled="!is_product || (!row.logings.includes('合作号') && !row.logings.includes('野生'))" :row="row">
                      </SupplierPopover>
                      <i v-if="row?.month_examples_data?.discount" style="background-color:#e6f8ea;color:#00b42a;">{{row?.month_examples_data?.discount}}折</i>
                      <!-- <i class="special" v-if="row.mcn && (row.mcn === '畅玩文化' || row.mcn.includes('畅玩达人'))" >畅玩达人</i> -->
                    </div>
                    <div class="icon-wrap">
                      <img v-if="row.logings === '签约号' && row.contract_type=='独家'" src="@/assets/images/djdr.png" >
                      <img v-else-if="row.logings === '签约号' && ['非独家，不分商机先后','非独家，优先商机'].includes(row.contract_type)" src="@/assets/images/fdjdr.png" >
                      <img v-else-if="row.logings === '签约号' && row.contract_type=='弱绑定签约达人'" src="@/assets/images/rbddr.png" >
                      <img v-if="row.is_month_examples=='1'" src="@/assets/images/bykl.png" >
                      <el-popover
                        class="pop-special_saletype"
                        v-if="row.special_saletype"
                        placement="top-start"
                        title=""
                        width="200"
                        trigger="hover">
                        <div v-html="row.special_saledesc || '暂无描述'"></div>
                        <img slot="reference" :src="require(`@/assets/images/${row.special_saletype}.png`)"  >
                      </el-popover>
                      <el-tooltip v-if="row.bl_status == '是'" effect="dark" content="该达人支持保量或历史合作项目中有保量案例，具体条款详见合作明细。" placement="top">
                        <img :src="require(`@/assets/images/支持保量.png`)"  >
                      </el-tooltip>
                      <img v-if="row.is_cooling == 1" :src="require(`@/assets/images/冷却.png`)"  >
                      <img v-if="row.isHistorySign" :src="require(`@/assets/images/历史签约号.png`)"  >
                      <el-tooltip v-if="row.isNewSign" effect="dark" content="1、首次入库，成为签约号的前三个自然月。2、非首次入库，从别的账号状态(例如野生)首次改成签约号的前三个自然月。3、非首次入库，从签约号状态改成别的状态(例如野生)再改回签约号的前三个自然月。" placement="top">
                        <img :src="require(`@/assets/images/新签约.png`)"  >
                      </el-tooltip>
                    <img v-if="row?.search_tags?.includes('精选激励达人')" src="@/assets/images/精选激励达人.png" >
                      <ContactWayPopover v-if="row.is_sup_limit == 1 && row.is_black != 1 && row.is_sup_black != 1" :mid="row.id" :type="2"></ContactWayPopover>
                    </div>
                    <RelatedTalents :row="row"></RelatedTalents>
                    <div class="mechanism">
                      <span :title="row.location">{{ row.location }} | </span>
                      <span style="cursor: pointer;" @mouseenter="showStarChangeHistory($event,row)" @mouseleave="hideStarChangeHistory">机构：{{ row.star || '-' }}</span>
                    </div>
                    <div class="default-order">
                      <!-- <span>内容：<i>{{ row.avg_quality }}</i></span>
                      <span>合作：<i>{{ row.avg_experience }}</i></span>
                      <span>数据：<i>{{ row.avg_effect }}</i></span> -->
                      <!-- 0724 违约商单暂不展示 -->
                      <!-- <span class="txt" v-if="row.error_bussiness_order_num">违约商单：{{ row.error_bussiness_order_num }}</span> -->

                    </div>
                  </div>
                </div>
              </template>
            </vxe-column>
                      <!-- 内容找人时才有的列 -->
          <vxe-column v-if="commonQuery.searchType == '内容找人'" title="相关笔记" field="video_count" width="100" :sortable="true">
            <template #default="{row}">
                <span style="color:#ff6f28; cursor: pointer;">
                  {{row.video_count}}
                  <img :src="require('@/assets/images/相关笔记.png')" style="vertical-align:text-bottom;width:20px;">
                </span>
            </template>
          </vxe-column>
          <vxe-column
            v-for="(item, index) in myColumns"
            :key="item.field"
            :field="item.field"
            :fixed="item.fixed || ''"
            :title="item.title"
            :class-name="item.field.endsWith('_mychart') ? 'chart-wrap' : ''"
            :sortable="item.sortable"
            :titlePrefix="item.titlePrefix"
            :min-width="item.width || 180">
            <template #header v-if="item.titleStr">
              <span v-html="item.titleStr"></span>
            </template>
            <template #default="{column, row}">
              <div v-if="item.formatter && typeof item.formatter == 'function'">{{ item.formatter({cellValue:row[column.field],row,column}) }}</div>
              <div class="bar-cell-wrap" style="width: 100%;" v-else-if="column.field.endsWith('_mychart')">
                <el-popover
                  v-if="row[column.field] && row[column.field].hasData"
                  placement="top"
                  title=""
                  width="300"
                  trigger="click">
                    <bar :info="row[column.field]" style="height: 160px; width: 300px"></bar>
                  <p slot="reference" class="p-no-data">{{ row[column.field].firstData+'%' || "" }}</p>
                </el-popover>
                <p v-else class="p-no-data">暂无数据</p>
              </div>
              <div class="price_text" v-else-if="column.field.endsWith('c_count')">
                  <el-popover placement="bottom" trigger="click">
                    <div class="table-wrap">
                      <el-table v-if="detailTableData" v-loading="detailTableLoading" height="300" :data="detailTableData" size='small' :header-cell-style="{ background: '#f5f7fa' }">
                        <el-table-column v-for="(item, idx) in detail_field" :key="idx" :fixed="item.fields === 'product' ? 'left' : false"
                          width="150" :sortable="item.ispx ? 'custom' : false" :prop="item.fields" :label="item.name" ></el-table-column>
                        <template #empty>
                          <div class="no-data-wrap">
                            <span>暂无数据</span>
                          </div>
                        </template>
                      </el-table>
                      <el-pagination
                        style="margin-top: 10px;text-align: center;"
                        small
                        background
                        layout="prev, pager, next"
                        :page-size="detailTableLimit"
                        :total="detailTableTotal"
                        :current-page.sync="detailTablePage"
                        @current-change="handleClick(row, column.field)">
                      </el-pagination>
                    </div>
                    <div slot="reference">
                      <div style="color:#606266;font-size: 14px;font-weight: 400;cursor: pointer;" @click="handleClick(row, column.field)">
                        {{handleNum(row[column.field], column)}}
                      </div>
                    </div>
                  </el-popover>
                </div>
              <div v-else-if="column.field == 'accounttype'">
                  <el-popover
                    v-if="row.accounttype && row.accounttype.split"
                    trigger="hover"
                  >
                    <span v-if="row.contenttype" class="popover-tag-wrap">
                      <template v-if="row.contenttype && row.contenttype.split">
                        <i v-for="(tag, tagIdx) in row.contenttype.split(',')" :key="tagIdx">{{ tag }}</i>
                      </template>
                    </span>
                    <span slot="reference">
                        <i class="tag" v-for="(tag, tagIdx) in row.accounttype.split(',')" :key="tagIdx">{{ tag }}</i>
                    </span>
                  </el-popover>
                </div>
                <div v-else-if="column.field == 'persona'|| column.field == 'label'">
                  <i class="tag" v-for="(tag, tagIdx) in row?.[column.field]?.split(',')" :key="tagIdx">{{ tag }}</i>
                </div>
                <div v-else-if="column.field == 'segment_labels'">
                  <i class="tag" v-for="(tag, tagIdx) in row?.segment_labels?.split(',')" :key="tagIdx">{{ tag }}</i>
                </div>
                <div v-else-if="column.field == 'industry_tags'">
                  <i class="tag" v-for="(tag, tagIdx) in row?.[column.field]?.split(' ')" :key="tagIdx">{{ tag }}</i>
                </div>

              <div class="price_text" v-else-if="['sixtyoverprice', 'price_73',].includes(column.field)">
                {{row[column.field] ? "￥"+(Number(row[column.field]).toLocaleString()) : '暂无报价'}}
              </div>
              <span v-else>{{ handleNum(row[column.field], column) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="操作" fixed="right" width="190">
              <template #default="scope">
                <div style="display: flex;justify-content: center;flex-wrap: wrap;">
                  <el-dropdown @command="(command)=>handleAddCommand(scope,command)">
                    <span style="width: 30px;">
                      <el-tooltip placement="top" content="添加达人">
                        <img class="rowBtn"  src="@/assets/plus.png" alt="">
                      </el-tooltip>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="add-to-cart">添加至达人清单</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-tooltip placement="top" content="查看主页">
                    <img class="rowBtn" @click="onToDrHome(scope)" src="@/assets/home.png" alt="去主页">
                  </el-tooltip>
                  <!-- <img class="rowBtn" @click="showCalculator(scope)" src="@/assets/calc.png" alt=""> -->
                  <el-tooltip placement="top" content="查看达人详情">
                    <img class="rowBtn" @click="tableBtnClick(scope)" src="@/assets/file.png" alt="">
                  </el-tooltip>
                  <el-dropdown @visible-change="handleDrop($event, scope.row)">
                    <span style="cursor: pointer">
                      <img class="rowBtn" src="@/assets/more.png" alt="">
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <template v-if="dropRole.isread || dropRole.isedit">
                        <el-dropdown-item v-if="dropRole.isedit" @click.native.capture="toCrmLibrary(scope, 'add')">媒体库编辑</el-dropdown-item>
                        <el-dropdown-item v-if="dropRole.isread" @click.native.capture="toCrmLibrary(scope, 'detail')">媒体库详情</el-dropdown-item>
                      </template>
                      <el-dropdown-item v-else-if="dropdownLoading">
                          加载中<i class="el-icon-loading"></i>
                      </el-dropdown-item>
                      <el-dropdown-item v-else>
                          无可操作项
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </vxe-column>
        </vxe-table>
        <vxe-pager
          background
          :align="'right'"
          class="my-list-pager"
          @page-change="pageChange"
          :current-page.sync="pager.page"
          :page-size.sync="pager.limit"
          :page-sizes="[15, 30, 50]"
          :total="pager.total"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
        </vxe-pager>
      </div>

      <el-dialog title="自定义列" :visible.sync="customDialog.show" class="custom-col-dialog-wrap">
        <h3>请筛选您要展示的达人指标</h3>
        <div style="color:#4080FF"><i class="el-icon-warning" style="margin-right: 6px;margin-bottom: 20px;"></i>选中的指标将被展示于达人列表中</div>
        <el-checkbox-group v-model="customDialog.form.checkList">
          <el-checkbox
            v-for="(item, index) in baseColumns"
            :key="index"
            :label="item.title"
            :disabled="item.disabled || false"
            style="margin-bottom: 10px"
          >
          </el-checkbox>
        </el-checkbox-group>

        <el-divider></el-divider>
        <h5 style="font-size: 14px;">展示报价类型</h5>
        <el-radio-group v-model="customDialog.form.priceType">
          <el-radio v-for="(item, index) in priceTypeList" :key="index" :label="item.label" :disabled="item.disabled">{{item.name}}</el-radio>
        </el-radio-group>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="customDialog.show = false">取 消</el-button>
          <el-button size="small" type="primary" @click="customDialogConfirm">确 定</el-button>
        </div>
      </el-dialog>
      <exportDialg :exportDialg = "exportDialg" @exportDialgConfirmFn ="exportDialgConfirmFn"></exportDialg>
      <RelatedNoteModal  ref="relatedNote" :otherQuery="{descsearch:commonQuery.descsearch || '',desctimesearch:commonQuery.desctimesearch || ''}" :talentInfo="relatedNoteTalentInfo" />
      <div ref="custom_popver" class="custom-popver">
        <vxe-table :data="starChangeHistory">
          <vxe-column field="optdt" title="更新时间" ></vxe-column>
          <vxe-column field="oldval" title="更新前机构" ></vxe-column>
          <vxe-column field="newval" title="更新后机构" ></vxe-column>
        </vxe-table>
      </div>
    </div>
    <PjModal ref="pjModal" :show.sync="pjModalShow" :id="pjId"></PjModal>
    <!-- 自孵化排期 -->
    <Calendar :outerDiaVisible.sync="outerDiaVisible" :info="calendarInfo"></Calendar>
    <!-- 批量锁档 -->
    <ScheduleBatchAddModal ref="ScheduleBatchAddModal"></ScheduleBatchAddModal>
  </div>

</template>
<script>
import * as XLSX from 'xlsx'
export default {
  props: {
    commonQuery: {
      type: Object,
      default: () => {}
    },
    isShowCalendar: {
      type: Number,
      default: 0
    }
  },
  components: {
    Bar: () => import('@/components/newEchart/Bar.vue'),
    exportDialg:() => import("../components/exportDialg.vue"),
    SupplierPopover: () => import("@/pages/kol-list/components/SupplierPopover.vue"),
    ContactWayPopover: () => import("@/pages/kol-list/components/ContactWayPopover.vue"),
    RelatedNoteModal: () => import("../components/RelatedNoteModal.vue"),
    PjModal: () => import("@/pages/kol-list/components/PjModal.vue"),
    RelatedTalents: () => import("@/pages/kol-list/components/RelatedTalents.vue"),
    Calendar: () => import("@/components/calendar/calendar.vue"),
    ScheduleBatchAddModal: () => import("@/pages/kol-list/components/ScheduleBatchAddModal.vue"),

  },
  data() {
    return {
      outerDiaVisible: false,
      calendarInfo: {},
      pjModalShow: false, // 查看"相关视频"的达人
      pjId:'',
      is_product: false, //是否是产品侧人员权限
      priceTypeList:[
        {label:1, name:'图文报价',value:'_73',disabled:false},
        {label:2, name:'视频报价',value:'0',disabled:false},
      ],
      customDialog: {
        show: false,
        form: {
          checkList: [],
          priceType: 2,
          // cooperateList: [],
        },
        realForm: {
          checkList: [],
          priceType: 2,
          // cooperateList: [],
        }
      },
      query: {},
      pager: {
        page: 1,
        limit: 15,
        total: 0
      },
      sort: 'fans',   // 排序字段
      sortType: 1,  // 0 升序  1：降序
      tableParams: {},
      vxeTableData: [],
      barData: {
        xAxis: [],
        data: [
          {
            color: '#3F90FD',  // 封装时添加的属性，会添加至itemStyle配置中
            name: '',
            type: 'line',
            smooth: true,
            data: [],
            ...{
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(63, 144, 253, 0.2)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(255, 255, 255, 0.01)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                },
              }
            },  // 传入任何官方支持的配置
          },
        ],
        custom: {
          legend: {show: false},
          yAxis: { show: false },
          xAxis: {
            axisLabel: {
              fontSize: 12,
              rotate: 45,
            }
          },
          grid: {
            left: 0,
            right: 0
          },
          tooltip: {
            enterable: true,
            appendToBody: true,
            formatter: (params, ticket, cb) => {
              let id = params[0].data.id
              if (this.hoveredChart[id]) {
                if (this.hoveredChart[id].status === 'finished') {
                  return this.handleHoverData(params, this.hoveredChart[id])
                } else {
                  return 'Loading'
                }
              } else {
                this.hoveredChart[id] = {
                  status: 'pending'
                }
                this.getHoverFun(params, ticket, cb)
              }
            }
          },
          series: [
            {
              itemStyle : { normal: {label : {show: true}}}
            }
          ]
        },
      },
      // 已经获取过的悬浮图表数据
      hoveredChart: {},
      baseColumns: [
        { title: '分成税率', field: 'devidedtax', disabled:false, width: 160, sortable: true, fixed: '', },
        { title: `合作次数`, field: `c_count`, width: 200, sortable: true, fixed: ''},
        { title: '畅玩细分标签', field: 'segment_labels', disabled:false, width: 140, sortable: false, fixed: '', titlePrefix: {content: '该达人的畅玩细分标签，若没有你需要的分类，欢迎补充！'}},
        { title: `利润率`, field: `profit_rate_mychart`, xField: 'profit_rate_time', yField: 'profit_rate', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作执行完成数据，图表日期为视频发布日期；排序规则：利润率降序'}},
        { title: '图文报价', field: 'price_73', width: 200, sortable: true, fixed: 'right'},
        { title: '视频报价', field: 'sixtyoverprice', width: 200, sortable: true, fixed: 'right'},
        { title: '内容分类', field: 'accounttype',width: 160, sortable: false, fixed: '', },
        { title: '擅长内容', field: 'label', width: 160, sortable: false, fixed: '', },
        { title: '合作行业', field: 'industry_tags', width: 160, sortable: false, fixed: '', },
        { title: '个性标签', field: 'persona',width: 160, sortable: false, fixed: '', },
        { title: '粉丝数', field: 'fans', width: null, sortable: true, fixed: ''},
        { title: '粉丝量变化幅度', field: 'growth_index', width: null, sortable: true, fixed: '',formatter:({ cellValue})=>{ return cellValue? cellValue+ '%':''} },
        { title: '阅读中位数', field: 'median', width: null, sortable: true, fixed: ''},
        { title: '互动中位数', field: 'interact_median', width: null, sortable: true, fixed: ''},
        { title: '千赞笔记比例', field: 'like_1000_pct', width: null, sortable: true, fixed: '', formatter:({ cellValue})=>{ return cellValue? cellValue+ '%':''} },
        { title: '百赞笔记比例', field: 'like_100_pct', width: null, sortable: true, fixed: '', formatter:({ cellValue})=>{ return cellValue? cellValue+ '%':''}  },
        { title: '互动粉丝占比', field: 'interact', width: null, sortable: true, fixed: '', formatter:({ cellValue})=>{ return cellValue? cellValue+ '%':''}  },
        { title: '活跃粉丝占比', field: 'fansactivepct', width: null, sortable: true, fixed: '',formatter:({ cellValue})=>{ return cellValue && cellValue != "0" ? cellValue + '%':''} },
        { title: '男粉占比', field: 'i_percent', disabled:false, width: 130, sortable: true, fixed: '', formatter:({ cellValue})=>{ return (cellValue ?? '-') + '%'} },
        { title: '女粉占比', field: 'o_percent', disabled:false, width: 130, sortable: true, fixed: '', formatter:({ cellValue})=>{ return (cellValue ?? '-') + '%'} },
      ],
      hide_fields: [],
      starChangeHistory: [],
      exportDialg:{
        show: false,
        checkListInit:[],
        baseColumns:[],
        quotationColumns:[],
        fansColumns: [],
        worksColumns:[],
        audienceColumns:[],
        liveCheckList: []
      },
      searchOptionsObj: {
        detail_field: [
          {
            fields:"product",
            name:"营销标的",
          },
          {
            fields:"order_num",
            name:"订单单号",
          },
          {
            fields:"ordertype",
            name:"产品类型",
          },
          {
            fields:"ordertype",
            name:"产品名",
          },
          {
            fields:"profit_rate",
            name:"实际利润率",
          },
          {
            fields:"talent_price",
            name:"达人报价",
          },
          {
            fields:"at_total_expenses",
            name:"总支出（税后）",
          },
          {
            fields:"at_expenses",
            name:"实际支付成本税后",
          },
        ],
      },
      detailTableLoading: false,
      detailTableData: [],
      detailTableTotal: 0,
      detailTablePage: 1,
      detailTableLimit: 15,
      detail_field:[],
      loading:false,
      subPageList: [],
      relatedNoteTalentInfo: null, //查看"相关笔记"的达人
      dropdownLoading: false,
      dropRole: {
        isread: false,
        isedit: false
      }
    }
  },
  watch: {
    commonQuery: {
      deep: true,
      handler(val, oldVal) {
          this.pager.page = 1
          this.query = this._.cloneDeep(val);
          if(val.searchType !== oldVal.searchType && val.searchType == '内容找人'){
          this.sort = ''
          this.sortType = 1
        } else if(val.searchType !== oldVal.searchType && val.searchType == '昵称找人' || !this.sort){
          this.sort = 'rank'
          this.sortType = 1
        }
          setTimeout(() => {
            this.getMyTable()
          }, 0);
      },
    },
    'commonQuery.logings'(val){
      if (val == '签约号') {
         // 如果选择签约号，则优先按 独家达人 排序
        this.$refs.mainTableRef.clearSort(this.sort)
        this.sort = 'contract_type'
        this.sortType = 1
      }
    },
    '$store.state.is_product': {
      handler(val){
        this.is_product = val
      },
      immediate: true
    }
  },
  computed: {
    myColumns() {
      let columns = this._.cloneDeep(this.baseColumns)
      let allcheckList = [...this.customDialog.realForm.checkList]
      columns = columns.filter(x => allcheckList.includes(x.title))
      // let otherColumns = [ //抖音那边是有区分产品 小红书没有区分
      //   { title: `合作次数`, field: `c_count`, width: 200, sortable: false, fixed: ''},
      //   { title: `利润率`, field: `profit_rate_mychart`, xField: 'profit_rate_time', yField: 'profit_rate', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作执行完成数据，图表日期为视频发布日期；排序规则：利润率降序'}},
      //   { title: `返点比例`, field: `profit_rate_mychart`, xField: 'rebate_rate_time', yField: 'rebate_rate', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作执行完成数据，图表日期为视频发布日期；排序规则：合作时间降序'}}
      // ]
      let otherColumns = []
      // if(!this.hide_fields.includes("c_count")) {
      //   otherColumns.push({ title: `合作次数`, field: `c_count`, width: 200, sortable: false, fixed: ''},)
      // }
      // if(!this.hide_fields.includes("profit_rate")) {
      //   otherColumns.push({ title: `利润率`, field: `profit_rate_mychart`, xField: 'profit_rate_time', yField: 'profit_rate', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作执行完成数据，图表日期为视频发布日期；排序规则：利润率降序'}})
      // }
      // if(!this.hide_fields.includes("rebate_rate")) {
      //   otherColumns.push({ title: `返点比例`, field: `rebate_rate_mychart`, xField: 'rebate_rate_time', yField: 'rebate_rate', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作执行完成数据，图表日期为视频发布日期；排序规则：合作时间降序'}})
      // }
          // columns.push({ title: '图文报价', field: 'price_73', width: 200, sortable: true, fixed: 'right'})
          // columns.push({ title: '视频报价', field: 'sixtyoverprice', width: 200, sortable: true, fixed: 'right'})
      if(!this.query.logings?.includes('签约号')){
        //'分成税率' 只有签约号才显示
        const index = columns.findIndex(item => item.field === 'devidedtax')
        if(index != -1){
          columns.splice(index, 1)
        }
      }
      return [...otherColumns, ...columns]
    }
  },
  created() {
    this.hide_fields = JSON.parse(localStorage.getItem("xhs_hide_fields") || JSON.stringify([]))
    if(!this.hide_fields.includes("devidedrate")) {
      this.baseColumns.unshift({ title: '媒体侧自然返点', disabled:true,  field: 'devidedrate', width: 180, sortable: true, fixed: '', titlePrefix: {content: '签约号和自孵化号以运营填写的建议返点比例%为准，合作号/野生优先展示短视频一口价产品的建议返点比例。'}})
    }
    let checkList = JSON.parse(localStorage.getItem("checkList") || JSON.stringify([]))
    if (checkList.length) {
      this.customDialog.form.checkList = [...new Set([...this.baseColumns.filter(item=>item.disabled).map(item=>item.title),...checkList])]
      this.customDialog.realForm.checkList =  [...new Set([...this.baseColumns.filter(item=>item.disabled).map(item=>item.title),...checkList])]
    } else {
      this.customDialog.form.checkList = ["预期播放量","媒体侧自然返点","粉丝数","预期CPM",'内容分类','畅玩细分标签', '行业标签', '男粉占比', '女粉占比', '粉丝年龄层','真人出镜']
      this.customDialog.realForm.checkList = ["预期播放量","媒体侧自然返点","粉丝数","预期CPM",'内容分类','畅玩细分标签', '行业标签', '男粉占比', '女粉占比', '粉丝年龄层','真人出镜']
    }
    let priceType =  2;
    this.customDialog.form.priceType = priceType
    this.customDialog.realForm.priceType = priceType
    localStorage.setItem("priceType", JSON.stringify(this.customDialog.realForm.priceType));
  },
  methods: {
    async onDrCartBatchJoin(){
      const rows = this.$refs.mainTableRef?.getCheckboxRecords()
      if (!rows.length) {
        this.$modal.message({status: 'warning', content: '请先选择达人'})
        return
      }
      const data = await this.$axios.get('api.php?m=cart|api|gx&a=batchAdd', {
        params:{
          lids: rows.map(row => row.id).join(','),
          plat: '小红书'
        },
        headers: { showLoading: false },
      })
      this.$message.success('添加成功')
      this.$store.dispatch('shoppingCart/refreshCount')
    },
    showPjModal(row){
      this.pjModalShow = true
      this.pjId = row.id
    },
    showCalendarDia(item) {
      this.calendarInfo = {
        plat: '小红书',
        shortid: item.shortid,
        starid: item.starid || ""
      }
      this.outerDiaVisible = true
    },
    batchLockHandle() {
      const checkedData = this.$refs.mainTableRef?.getCheckboxRecords()
      this.$refs.ScheduleBatchAddModal.show(checkedData)
    },
    rowClassName({row}){
      if(row?.is_black == 1 || row?.is_sup_black == 1){
        return 'gray-color'
      }else if (row?.is_ban == 1 || row?.ban_data?.reason){
        return 'ban-color'
      }
    },
    onCopy(){
      alert('复制链接成功')
    },
    handleClick(row,field){
      console.log('this.plat :>> ', this.plat);
      console.log('field :>> ', field);
      console.log('row :>> ', row);
      let order_type = field?.split("c_count")?.[0] || ''
        this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
          if(["订单单号","产品类型","营销标的","达人报价","实际利润率"].includes(x.name)){
            return x
          }
        })

      let params = {
        order_type,
        plat: "小红书",
        page: this.detailTablePage,
        limit: this.detailTableLimit,
        shortid: row.shortid,
      }
      this.detailTableLoading = true
      this.$axios.post('/api.php?m=case|api|gx&a=drcaselist', params, {headers: { showLoading: false}}).then(res => {
        let {rows = [], totalCount = 0} = res || {}
        this.detailTableTotal = totalCount
        this.detailTableData = rows
      }).catch( err => {})
      .finally(() => {
        this.detailTableLoading = false
      })

    },
    tableBtnClick(args) {
      let { row, column } = args
      if (column.field == 'video_count') {
        this.relatedNoteTalentInfo = {...row}
        this.$refs.relatedNote.show()
        return
      }
      let routeData = this.$router.resolve({
        path: "/rednote",
        query: {
          secuid: row.secuid,
          logings: row.logings,
          shortid: row.shortid,
          mid:row.id,
        },
      });
      let page = window.open(routeData.href, "_blank");
      this.subPageList.push(page)

      // 详情页浏览频率埋点
      let logParams = {
        type: 4,
        plat: 4,
        shortid: row.shortid || "",
        secuid: row.secuid || ""
      }
      this.$api.setUseLog(logParams)
    },
    onToDrHome(scope){
      const url = `${scope.row.homepage}`
      window.open(url)
    },
    async onDrCartJoin({row}){
      const data = await this.$axios.get('api.php?m=cart|api|gx&a=add', {
        params:{
          lid: row.id,
          plat: '小红书'
        },
        headers: { showLoading: false },
      })
      this.$message.success('添加成功')
      this.$store.dispatch('shoppingCart/refreshCount')
    },
    handleAddCommand(scope,command){
      switch (command) {
        case 'add-to-cart':
          this.onDrCartJoin(scope)
          break;
      }
    },
    exportDialgConfirmFn(checkList){
      if(checkList.length == 0){
        this.$message.error('请选择导出列')
        return
      }
      else{
        this.exportHandle(checkList)
      }
    },
    showExportDialg(){
    this.exportDialg.baseColumns = [
      {
          title: "昵称",
          field: "nickname",
          disabled:true,
      },
      {
          title: "账号ID",
          field: "uniqueId",
          disabled:true,
      },
      {
          title: "UID",
          field: "shortid",
          disabled:true,
      },
      {
          title: "主页链接",
          field: "homepage"
      },
      {
          title: "一级分类",
          field: "accounttype"
      },
      {
          title: "二级分类",
          field: "contenttype"
      },
      {
          title: "所属机构",
          field: "star"
      },
      {
          title: "账号类型",
          field: "account_type"
      }
    ]
    this.exportDialg.quotationColumns = [
      {
          title: "图文报价",
          field: "price_73"
      },
      {
          title: "视频报价",
          field: "sixtyoverprice"
      },

    ]
    this.exportDialg.fansColumns = [
      {
          title: "粉丝数/W",
          field: "fans"
      },
      {
          title: "男粉占比",
          field: "i_percent"
      },
      {
          title: "女粉占比",
          field: "o_percent"
      },
      {
          title: "18-23岁粉丝占比",
          field: "fans_age_pct_1"
      },
      {
          title: "24-30岁粉丝占比",
          field: "fans_age_pct_2"
      },
      {
          title: "31-40岁粉丝占比",
          field: "fans_age_pct_3"
      },
      {
          title: "41-50岁粉丝占比",
          field: "fans_age_pct_4"
      },
      {
          title: "50+岁粉丝占比",
          field: "fans_age_pct_5"
      },
    ]
    this.exportDialg.worksColumns = [
      {
          title: "阅读中位数",
          field: "median"
      },
      {
          title: "互动中位数",
          field: "interact_median"
      },
      {
          title: "千赞笔记比例",
          field: "like_1000_pct"
      },
      {
          title: "百赞笔记比例",
          field: "like_100_pct"
      },
      {
          title: "互动粉丝占比",
          field: "interact"
      },
      {
          title: "活跃粉丝占比",
          field: "fansactivepct"
      },

    ]
    this.exportDialg.audienceColumns = [

    ]
    this.exportDialg.checkListInit = ["昵称","账号ID","UID","主页链接","一级分类","二级分类","图文报价","视频报价","粉丝数/W","阅读中位数","互动中位数","千赞笔记比例","百赞笔记比例","互动粉丝占比","活跃粉丝占比",]
    this.exportDialg.show = true
    },
    exportHandle(checkList) {
      let checkedData = this.$refs.mainTableRef?.getCheckboxRecords()
      if(!checkedData.length && localStorage.getItem('uid') != 1) {
        this.$message.warning(`请勾选要导出的达人！`)
        return
      }

      // if(localStorage.getItem('uid') != 1 && checkedData.length > 30) {
      //   this.$message.warning(`每次最多可导30个达人！`)
      //   return
      // }

      let params = {
        page: 1,
        page_size: localStorage.getItem('uid') == 1 ? 10000 : this.pager.limit,
        search_type: 'export',
        shortids: checkedData.map(x => x.shortid).filter(x => x).join(),
        plat: 4
      }

      this.loading = true
      let url = `/api.php?m=index|api|gx&a=search`
      if(!checkedData.length && localStorage.getItem('uid') == 1) {
        let specialParams = this.handleQuery()
        let {main, other = ''} = specialParams
        if (other) {
          url += `&${other}`
        }
        params = {
          ...this.tableParams,
          page: 1,
          page_size: 10000,
          search_type: 'export',
          plat: 4
        }
      }

      this.$axios.get(url, { params, headers: { showLoading: false }, }).then(res => {
        this.loading = false
        let {list = [], stats = {}} = res || {}
        this.exportFrequency = stats.export
        if(!list.length) {
          this.$message.warning(`没有需要导出的数据！`)
        }else {
          // 数据中的对象下的字段补充到row本身，来导出，注意字段名是否重复
          list.forEach((item, index)=>{
            if (item.month_examples_data) {
              [
                'account_id',
                'is_hot',
                'is_must',
                'discount',
                'reason',
                'is_real_person',
                'is_same_price',
                'notes',
                'rank_score',
              ].forEach(key =>{
                item[key] = item.month_examples_data[key]
              })
            }
          })
          let allcolumns = [...this.exportDialg.baseColumns,...this.exportDialg.quotationColumns,...this.exportDialg.fansColumns,...this.exportDialg.worksColumns,...this.exportDialg.audienceColumns]
          let titles = []
          let fileds = []
          fileds = allcolumns.filter(x => checkList.includes(x.title)).map(x => x.field)
          titles = allcolumns.filter(x => checkList.includes(x.title)).map(x => x.title)

          // let fileds = ['starid', 'accounttype', 'contenttype', 'nickname', 'uniqueid', 'shortid', 'homepage', 'fans', 'i_percent', 'fans_age_pct_1', 'fans_age_pct_2', 'fans_age_pct_3', 'avg_play5', 'sd_avg_play5', 'twentyprice', 'sixtyprice', 'sixtyoverprice', 'cpm', 'expectedplay']
          // let titles = ['星图ID', '一级分类', '二级分类', '昵称', '账号ID', 'UID', '主页链接', '粉丝量（W）', '男粉占比', '18-23岁年龄层粉丝占比', '24-30岁年龄层粉丝占比', '31-40岁年龄层粉丝占比', '近5个日常视频平均播放量（W）', '近5个商单视频平均播放量（W）', '1-20报价', '21-60报价', '60+报价', '预期CPM', '近30天播放量']
          let data = list.map(x => {
            let cur = []
            fileds.forEach(field => {
              let result = {}
              if(['avg_play5', 'sd_avg_play5', 'expectedplay'].includes(field)){
              result = this.fmt(x[field], { micrometer: true })
              }else if (['fans'].includes(field)){
                  result = this.fmt(x[field]/10000, { micrometer: true })
              }else{
                  result = x[field]
              }
              cur.push(result)
            })
            return cur
          })

          const ws = XLSX.utils.aoa_to_sheet([titles, ...data]);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
          XLSX.writeFile(wb, `小红书.xlsx`);
          this.$message.success(`已为您导出${list.length}条达人数据`)
        }
      }).finally(() => {
        this.loading = false
      })
        // 导出埋点
        let exportColumns = [...this.exportDialg.baseColumns,...this.exportDialg.quotationColumns,...this.exportDialg.fansColumns,...this.exportDialg.worksColumns,...this.exportDialg.audienceColumns]

        let logParams = {
        type: 42,
        plat: 4,
        shortids: params.shortids || "",
        export_fields: exportColumns.filter(x => checkList.includes(x.title)).map(x => x.field).join(),
        tags: JSON.parse(localStorage.getItem("tagsParams")) || []
      }
      this.$api.setUseLog(logParams)
    },
    showCustomDialog() {
      this.customDialog.form = this._.cloneDeep(this.customDialog.realForm)
      this.customDialog.show = true
    },
    customDialogConfirm() {
      this.customDialog.realForm = this._.cloneDeep(this.customDialog.form)
      localStorage.setItem("checkList", JSON.stringify(this.customDialog.realForm.checkList));
      // localStorage.setItem("cooperateList", JSON.stringify(this.customDialog.realForm.cooperateList));
      localStorage.setItem("priceType", JSON.stringify(this.customDialog.realForm.priceType));

      this.customDialog.show = false
      this.getMyTable()
    },
    getMyTable() {
      let params = this.handleQuery()
      let {main, other = ''} = params
      let {page, limit: page_size} = this.pager

      // 如果选择签约号，则优先按 独家达人 排序
      if (params.main.logings == '签约号' && !this.sort) {
        this.sort = 'contract_type'
        this.sortType = 1
      }

      params = {
        ...main,
        page,
        page_size,
        sort: this.sort,
        sort_type: this.sortType,
        plat: 4
      }

      let newQuery = {}
      Object.keys(params).forEach(x => {
        if(x.startsWith('price_') && x.split('_').length < 3) {
            let keyName = x.split('_')[1]
            const keyMap = {
              1: 'price_73',
              2: 'sixtyoverprice',
            }
            newQuery[`${keyMap[this.customDialog.realForm.priceType]}_${keyName}`] = params[x]
        }else {
          newQuery[x] = params[x]
        }
      })
      let fans_price_type = localStorage.getItem('fans_price_type')
        let priceTypeList_copy = []
        priceTypeList_copy = this._.cloneDeep(this.priceTypeList)
        this.priceTypeList = priceTypeList_copy.map(item => {
          if(fans_price_type){
            item.disabled = true
          }else{
            if(fans_price_type == "0"){
              item.disabled = true
            }else{
              item.disabled = false
            }
          }
          return item
          })
        this.priceTypeList.forEach(x=>{
          if(x.value == fans_price_type){
            let priceType = x.label
            this.customDialog.form.priceType = priceType
            this.customDialog.realForm.priceType = priceType
            localStorage.setItem("priceType", JSON.stringify(this.customDialog.realForm.priceType));
          }
        })
          if(!fans_price_type || fans_price_type == "0"){
            let priceType = JSON.parse(localStorage.getItem("priceType"))
              ? JSON.parse(localStorage.getItem("priceType"))
              : 2;
            this.customDialog.form.priceType = priceType
            this.customDialog.realForm.priceType = priceType

          }

      this.tableParams = this._.cloneDeep(params)
      let url = `/api.php?m=index|api|gx&a=search`
      if (other) {
        url += `&${other}`
      }
      this.loading = true
      this.$axios.get(url, {params, headers: { showLoading: false },}).then(res => {
        this.loading = false
        let {list = [], page_info = {}} = res || {}
        let ids = []
        // 3个月前的日期节点
        const newSignDateFlag = this.dayjs().subtract(3, 'month')
        list.forEach(x => {
          ids.push(x.id)
          x.avg_quality = x.avg_quality ? Math.round(+x.avg_quality) : 0
          x.avg_experience = x.avg_experience ? Math.round(+x.avg_experience) : 0
          x.avg_effect = x.avg_effect ? Math.round(+x.avg_effect) : 0

          // 历史签约号
          x.isHistorySign = x.logings !== '签约号' && x.has_sign == 1
          // 新签约号，当前是签约号，并且签约时间在3个月内
          x.isNewSign = x.logings == '签约号' && newSignDateFlag.isBefore(x.last_sign_time)
        })
        this.vxeTableData = list


          if(window.scrollY > 450) {
            this.$nextTick(() => {
              window.scrollTo({
                top: 450,
                behavior: 'smooth'
              })
            })
          }
          this.getChart(ids)
          this.pager.total = +page_info.total
        }).finally(() => {
        this.loading = false
      })
        // 世明那边的埋点
      this.$api.setUserTimeLog()
    },
    handleQuery() {
      // 需要直接拼接到url上面的key
      let keyList = ['devidedrate_ge','fans_age', 'fans_grenders', ]
      let other = [], copyQuery = this._.cloneDeep(this.query)
      keyList.forEach(x => {
        if (copyQuery[x]) {
          other.push(copyQuery[x])
          delete copyQuery[x]
        }
      })
      return {
        main: copyQuery,
        other: other.join('&')
      }
    },
    getChart(ids) {
      if(!ids?.length) return
      this.$axios.get(`/api.php?m=index|api|gx&a=getTalentOrderMap&lids=${ids.join()}&order_type=小红书/微博`, {headers: { showLoading: false }}).then(res => {
        let {list = {}, bad_review_list = []} = res
        for (const key in list) {
          list[key]?.forEach(x => {
            let idx = this.vxeTableData.findIndex(y => y.id == x.mid)
            if (idx !== -1) {
              let chartMap = {}
              let countMap = {}
              this.myColumns.forEach(y => {

                if ((y.field.endsWith('_mychart') && y.field.includes(key)) || y.title.includes('利润率')) {
                  if( y.yField == "profit_rate" && (x[y.yField]?.length == 0 || !x[y.yField])){
                    chartMap[y.field] = x[y.yField]
                  }else{
                    let baseChart = this._.cloneDeep(this.barData)
                    baseChart.xAxis = (x[y.xField] || []).map(x => this.dayjs(x).format('MM-DD'))
                    baseChart.data[0].data = (x[y.yField] || [])
                    baseChart.data[0].name = y.title
                    // 判断是否有data数据 没有data数据的话 就不渲染图表
                    baseChart.hasData = baseChart.data[0].data?.length > 0
                    baseChart.firstData = baseChart.data[0].data?.[0]?.value || ""
                    chartMap[y.field] = baseChart
                  }
                } else if (y.field.endsWith('c_count')) {  // 各产品合作次数
                  countMap[y.field] = x?.total_count ? x?.total_count : 0
                }
              })
              this.vxeTableData.splice(idx, 1, {
                ...this.vxeTableData[idx],
                ...countMap,
                ...chartMap
              })
            }
          })
        }
        bad_review_list.forEach(x => {
          let idx = this.vxeTableData.findIndex(y => y.id == x.mid)
          if (idx !== -1) {
            this.$set(this.vxeTableData[idx],'warnTips','近180天有合作不满意记录')
          }
        })
      })
    },
    handleHoverData(params, data = {}) {
      let title = `<span style="font-size: 14px; font-weight: bold; color: #333; margin-bottom: 20px">${params[0].name}</span>`
      let content = `
        <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
          <span>订单号：</span>
          <span style="font-weight: bold;">${data.order_num || ''}</span>
        </div>
        <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
          <span>${params[0].seriesName}：</span>
          <span style="font-weight: bold;">${params[0].value || ''}</span>
        </div>
      `
      if (data.supplier_name && data.supplier_name !== '无') {
        content += `
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>供应商：</span>
            <span style="font-weight: bold;">${data.supplier_name}</span>
          </div>
        `
      }
      content += `
        <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
          <span>客户：</span>
          <span style="font-weight: bold;">${data.cust_name || ''}</span>
        </div>
        <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
          <span>营销标的：</span>
          <span style="font-weight: bold;">${data.product || ''}</span>
        </div>`
      return title + content
    },
    getHoverFun(params, ticket, cb){
      let id = params[0].data.id || ''
      this.$axios.get(`/api.php?m=index|api|gx&a=getMapDetail&cid=${id}`, {
        headers: { showLoading: false },
      }).then(res => {
        this.hoveredChart[id] = {
          status: 'finished',
          ...res
        }
        cb(ticket, this.handleHoverData(params, res || {}))
      }).catch(res => {
        this.hoveredChart[id].status = ''
      })
    },
    handleNum(value, column) {
      if (['sixtyoverprice', 'price_73',].includes(column.field)) {
        if (value) {
          return `¥${this.fmt(value, {micrometer: true})}`
        } else {
          return '-'
        }
      }
      if (column.title.endsWith('率')) {
        return value ? `${this.fmt(value)}%` : '0%'
      } else {
        return this.fmt(value, {micrometer: true}) || 0
      }
    },
    pageChange({ type, currentPage, pageSize }) {
      if (type == 'size') this.pager.page = 1
      this.getMyTable()
    },
    sortChange(args) {
      let { property, order } = args
      this.pager.page = 1
      this.sort = order ? property : ''
      this.sortType = order === 'desc' || !order ? 1 : 0
      this.getMyTable()
    },
    async showStarChangeHistory(event,row){
      if (!row?._starChangeHistory) {
        const data = await this.$axios.get('api.php?m=index|api|gx&a=talentSupLog', {
          params:{
            mid: row.id
          },
          headers: { showLoading: false },
        })
        this.$set(row,'_starChangeHistory',data )
      }
      this.starChangeHistory = row._starChangeHistory
      if (!this.starChangeHistory.length) {
        return
      }
      setTimeout(()=>{
        const contentRect = this.$refs.custom_popver.getBoundingClientRect()
        const rect = event.target.getBoundingClientRect()
        let top = rect.bottom - contentRect.height/2,left = rect.right + 4
        if(top + contentRect.height > innerHeight ) {
          top = innerHeight - contentRect.height - 10
        }
        this.$refs.custom_popver.style.top= top + 'px'
        this.$refs.custom_popver.style.left= left + 'px'
        this.$refs.custom_popver.classList.add('show')
        addEventListener("scroll", this.hideStarChangeHistory, { once: true })
      },0)

    },
    hideStarChangeHistory(){
      this.$refs.custom_popver.classList.remove('show')
      removeEventListener("scroll", this.hideStarChangeHistory)
    },
    toCrmLibrary({row}, type) {
      let origin = location.origin.includes('test') ? 'http://test.erp.changwankeji.com:8080' : 'https://erp.changwankeji.com:8188'
      let url = `${origin}/dist/index.html#/crmlibrary/${type}?id=${row.id}`
      window.open(url)
    },
    async handleDrop(flag, row){
      if(!flag){
        this.dropRole = {
          isread: false,
          isedit: false
        }
        return
      }
      this.dropdownLoading = true
      this.$axios.get(`/api.php?m=detail|api|gx&a=getAuth&lid=${row.id}`,{headers: { showLoading: false }}).then(async res => {
        this.dropRole = res || {}
      }).finally(() => {
        this.dropdownLoading = false
      })
    },
  }
}
</script>
<style scoped lang="less">
@import url('../../../assets/css/table-style.less');
.pj_icon{
    width: 20px;
    height: 20px;
    margin-left: 5px;
    cursor: pointer
  }
  .xhs-table-wrap{

    .gray-nickname{
      color: #A9AEB8;
    }
  }
  .img-wrap{
    position: relative;
    .sex{
      position: absolute;
      right: 10px;
      bottom: 0px;
    }
  }
  .tag{
    display: inline-block;
    border-radius: 2px;
    background: #F6F6F6;
    color: #333333;
    padding: 2px 4px;
    margin-bottom: 4px;
  }
  .tag+.tag{
    margin-left: 4px;
  }
  /deep/ .my-vxe-table-wrap{
    div{
      text-align: center;
    }
    .table-head-slot{
      text-align: left;
      .vxe-button{
        margin-left: 10px;
      }
    }
    .empty-table{
      position: sticky;
      top: 0;
      z-index: 100;
      .vxe-table--empty-block{
        min-height: 1px;
        overflow: hidden;
      }
    }
    .vxe-table--header-wrapper{
      background: #fff !important;
      .table-header-cell-wrap{
        .el-tooltip{
          margin-top: 0;
          margin-left: 5px;
        }
      }
    }
    .vxe-table--body{
      .chart-wrap{
        .vxe-cell{
          padding: 0;
        }
      }
    }
    .profile-wrap{
      display: flex;
      align-items: center;
      div{
        text-align: left !important;
      }
      .avatar{
        border-radius: 50%;
        width: 60px;
        height: 60px;
        margin-right: 10px;
      }
      .info-wrap{
        >*:not(:last-child){
          margin-bottom: 6px;
        }
        .nickname{
          color: #333333;
          font-size: 14px;
          font-weight: bold;
          display: flex;
          align-items: center;
          .i-calendar {
            width: 16px;
            height: 16px;
            margin-left: 5px;
            cursor: pointer;
          }
        }
        .tag-wrap{
          display: flex;
          align-items: center;
          font-size: 12px;
          >i{
            &:not(:last-child){
              margin-right: 6px;
            }
            border-radius: 2px;
            background: #F6F6F6;
            color: #333333;
            padding: 2px 4px;
            &.special{
              color: #FF5C00;
              background: #FFF2EB;
            }
          }
        }
        .address-wrap{
          display: flex;
          align-items: center;
          >.sex{
            margin-left: 7px;
          }
          >span{
            font-size: 12px;
            font-family: OPPOSans;
            font-weight: 500;
            color: #666666;
            margin-left: 7px;
          }
        }
        .industry-tags{
          font-size: 12px;
          color: #999999;
          >span:not(:last-child){
            margin-right: 5px;
          }
        }
        .mechanism{
          font-size: 12px;
          color: #999999;
        }
        .default-order{
          display: flex;
          align-items: center;
          >span{
            font-size: 12px;
            font-family: OPPOSans;
            font-weight: 500;
            color: #999999;
            margin-right: 10px;
            i{
              color: #FF5C00;
            }
          }
          .txt{
            display: inline-block;
            width: 100%;
            color: #FF4A53;
          }
        }
      }
    }
    .p-no-data{
      text-align: center;
      line-height: 120px;
      font-weight: 600;
    }
  }
  /deep/ .my-list-pager{
    justify-content: flex-end;
    .vxe-pager--wrapper{
      flex-grow: unset;
    }
  }

  .icon-wrap{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  }

// 自定义弹窗
.custom-popver{
    position: fixed;
    visibility: hidden;
    background-color: #fff;
    color: #333;
    text-align: left;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 10px;
    z-index: 1000;
    width: 470px;
    box-sizing: border-box;
  }
  .custom-popver.show{
    visibility:visible;
  }
</style>